import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/components/auth/AuthProvider';

export function LoggedInHero() {
  const { user } = useAuth();

  return (
    <div className="container mx-auto px-4 py-16">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-5xl md:text-6xl font-bold mb-6">
          Welcome back, {user?.user_metadata?.first_name || user?.email || 'Developer'}!
        </h1>
        <p className="text-xl text-muted-foreground mb-8">
          Ready to discover exceptional developers? Use our powerful tools to find and connect with the perfect talent for your team.
        </p>
        <Link to="/search">
          <Button size="lg" className="px-8 py-6 text-lg rounded-full">
            Start Searching <span className="ml-2">→</span>
          </Button>
        </Link>
      </div>
    </div>
  );
}
